import $ from 'jquery';

export default function modalSection() {
	const $html = $('html');
	const $modal = $('#modal');
	const $iframe = $modal.find('iframe');
	const toggler = $modal.data('toggler');

	if (toggler) {

		$iframe.on('load', function() {
			try {
				const href = $iframe[0].contentWindow.location.href
				const isBlank = href === 'about:blank';
				toggler.toggle(!isBlank);

			} catch(e) {
				toggler.close();
			}
		});

		$modal.on('click', function(e) {
			if (e.target === this) {
				toggler.close();
			}
		});

		toggler.on('toggle', function() {
			$html.toggleClass('is-modal-open', toggler.isOpen);
		});
	}
}



// WEBPACK FOOTER //
// ./source/scripts/sections/modal.js